<template>
  <div>
    <article>
      <h3 v-cloak>{{ filteredData.title }}</h3> // 作品タイトル
      <div v-for="p in filteredData.picture" v-if="p.id === '1'"> // v-if で写真の一枚目のみ
        呼び出し
        <img :src="p.path"> // 画像の URL
      </div>
      <p v-cloak>{{ filteredData.text }}</p> // 作品の詳しめ解説
      <p v-cloak> 制作年：{{ filteredData.year }}</p> // 制作年
      <p v-cloak>{{ filteredData.role }}</p>
      <p v-cloak><a :href="filteredData.url" target="_blank">{{ filteredData.urlTitle
        }}</a></p> // 参照 URL と URL のタイトル
      <div v-for="p in filteredData.picture" v-if="p.id !== '1'"> // v-if で写真の一枚目以外
        を呼び出し
        <img :src="p.path"> // 画像の URL
      </div>
    </article>
  </div>
</template>

<script>
    export default {
        props: ['data'],
        computed: {
            filteredData: function () {
                let url = window.location.protocol+ '//' + window.location.host + '/works/';
                let matchData = this.data.filter(function(item, index){
                    if (item.slug === window.location.href.replace(url, '')) return true;
                });
                return matchData[0]
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/WorksDetail.vue